<template>
  <div class="orderDetails">
    <!-- 状态 -->
    <div class="header">
      <img :src="imgPath + 'bejingqieu.png'" alt />
      <div class="status flex">
        <qdd-icon class="icondui" color="#fff" size=".8rem"></qdd-icon>
        <div>
          <span class="bold">{{ detail.status_txt }}</span>
          <!-- <span class="bold" v-if="detail.status == 0 || detail.status == 11 ">已取消</span>
          <span class="bold" v-if="detail.status ==34 ">已关闭</span>
          <span class="bold" v-if="detail.status == 20 && detail.goods_type ==1">待发货</span>
          <span class="bold" v-if="detail.status == 30 && detail.goods_type ==1">待收货</span>
          <span class="bold" v-if="detail.status == 40 && detail.goods_type ==2">待确认</span> -->
          <!-- <span
            class="bold"
            v-if="(detail.goods_type == 2 && detail.status == 41) || (detail.goods_type != 2 && (detail.status == 41 || detail.status == 40))"
          >已完成</span> -->

          <div clss="desc" v-if="detail.status == 20 && detail.goods_type == 1">
            备货中，您的商品将很快发货
          </div>
          <div clss="desc" v-if="detail.status == 40 && detail.goods_type == 2">
            请联系商家自提
          </div>

          <div
            class="text_zi"
            v-if="detail.status == 30 && detail.goods_type != 2 && isShowTime"
          >
            您的商品已经发货了
            <p v-if="isShowTime">还剩 {{ verify_time_format }}自动确认收货</p>
          </div>
          <div
            v-if="
              (detail.goods_type == 2 && detail.status == 41) ||
              (detail.goods_type != 2 &&
                (detail.status == 41 || detail.status == 40))
            "
          >
            收货成功，期待与您再次相见
          </div>
        </div>
      </div>
    </div>

    <!--查看物流 -->
    <div
      v-if="
        detail.goods_type != 2 &&
        (detail.status == '30' ||
          detail.status == '40' ||
          detail.status == '20')
      "
    >
      <div class="address n_wuliu" @click="goWuliu(detail.logisticsMore)">
        <qdd-icon class="iconwuliu2 fl" color="red" size=".7rem"></qdd-icon>
        <span class="w117" v-if="detail.logisticsMore == 1"
          ><article>点击查看快递列表</article></span
        >
        <span class="w117 fl" v-if="detail.logisticsMore == 0 && traceCon.desc">
          <article>{{ traceCon.desc }}</article>
          <p>{{ traceCon.time }}</p>
        </span>
        <span class="wl_no" v-if="!traceCon.desc">暂无快递信息</span>
        <qdd-icon
          class="iconnavigate-right"
          v-if="traceCon.desc"
          color="#999"
          size=".7rem"
        ></qdd-icon>
      </div>
    </div>

    <!-- 地址 -->
    <div class="address" v-if="detail.goods_type != 2">
      <div class="flex">
        <qdd-icon class="iconposition" color="#FD3E3E" size="0.7rem"></qdd-icon>
        <div class="ml30">
          <div class="userName">
            {{ detail.ph_name }} {{ detail.ph_shouji }}
          </div>
          <div class="gray">{{ detail.region }}{{ detail.address }}</div>
        </div>
      </div>
    </div>
    <!-- 商品 -->
    <div class="goods flex">
      <img :src="detail.goods_image" alt />
      <div class="right_con">
        <p class="t_line2 goods_name">{{ detail.goods_name }}</p>
        <div class="gray" v-show="detail.specification != ''">
          规格：{{ detail.specification }}
        </div>
        <div class="flex_b">
          <div class="jifen flex">
            <span class="red">
              <strong></strong>
              {{ detail.price }}
            </span>
            <span class="badge">积分</span>
          </div>
          <div class="gray">X{{ detail.quantity }}</div>
        </div>
      </div>
    </div>
    <!-- 总计 -->
    <div class="total">
      <div class="wrap">
        <p class="flex_b">
          <span>合计</span>
          <span>{{ detail.order_amount }}</span>
        </p>
        <p class="flex_b" v-if="detail.goods_type != 2 && detail.status != 40">
          <span>运费</span>
          <span>
            {{ detail.free_shipping }}
            <span v-if="detail.freight_payer != 0">{{
              detail.ship_price_format
            }}</span>
          </span>
        </p>
        <p
          v-if="
            detail.freight_payer == 1 &&
            detail.is_calc_freight != 1 &&
            detail.if_free_shipping != 1
          "
        >
          <qdd-icon
            class="icongantanhao"
            color="#FD3E3E"
            size=".5rem"
          ></qdd-icon>
          <span class="fs24"
            >本单配送方式为物流，运费为预估价格，运费到付。</span
          >
        </p>
      </div>
    </div>
    <!-- 快递 -->
    <div v-if="detail.goods_type != 2">
      <div
        class="total express"
        v-if="detail.status == 30 || detail.status == 40"
      >
        <p>{{ detail.wl_name }}</p>
        <div class="exp_wl">{{ detail.wl_danhao }}</div>
        <button
          data-clipboard-action="copy"
          class="cobyDomObj red"
          :data-clipboard-text="detail.wl_danhao"
          @click="copyLink"
        >
          复制
        </button>
        <!-- <div class="flex_b">
          <span>{{detail.wl_name}}</span>
          <div class="flex_b">
            <p class="w_p">{{detail.wl_danhao}}</p> 
            <button
              data-clipboard-action="copy"
              class="cobyDomObj red"
              :data-clipboard-text="detail.wl_danhao"
              @click="copyLink"
            >复制</button>
          </div>
        </div> -->
      </div>
    </div>

    <!-- 订单信息 -->
    <ul class="list">
      <li class="flex_b">
        <span>订单编号</span>
        <div>
          <span res="copy">{{ detail.order_parent_sn }}</span>
          <button
            data-clipboard-action="copy"
            class="cobyDomObj red"
            :data-clipboard-text="detail.order_parent_sn"
            @click="copyLink"
          >
            复制
          </button>
        </div>
      </li>
      <li class="flex_b">
        <span>支付单号</span>
        <div>
          <span>{{ detail.order_sn }}</span>
        </div>
      </li>
      <li class="flex_b" @click="jump2" v-if="detail.is_snapshot && detail.is_snapshot==1 " >
        <span>交易快照</span>
        <div>
          <span>发生争议时可作为判断依据</span>
          <qdd-icon
            class="iconnavigate-right"
            color="#999"
            size=".5rem"
          ></qdd-icon>
        </div>
      </li>
      <li class="flex_b">
        <span>创建时间</span>
        <div>
          <span>{{ detail.add_time_format }}</span>
        </div>
      </li>

      <li class="flex_b">
        <span>运输方式</span>
        <div>
          <span>{{ detail.yf_mode_name }}</span>
        </div>
      </li>
      <li class="flex_b">
        <span>付款时间</span>
        <div>
          <span>{{ detail.pay_time_format }}</span>
        </div>
      </li>
    </ul>

    <!-- 联系商家 -->
    <a :href="'tel:' + detail.store_tel">
      <div class="contact">
        <qdd-icon class="iconkefu" color="#333" size=".7rem"></qdd-icon>
        <span class="goPhone">联系商家</span>
      </div>
    </a>

    <!-- 底部 -->

    <div class="footer">
      <div
        class="toPay"
        v-if="detail.status == 30"
        @click="goAffirm(detail.id)"
      >
        确认收货
      </div>
      <div
        class="toPay"
        v-if="detail.status == 40 && detail.goods_type == 2"
        @click="goAffirm(detail.id)"
      >
        确认兑换
      </div>
      <div
        v-if="
          detail.goods_type == 1 &&
          (detail.status == '30' ||
            detail.status == '40' ||
            detail.status == '20') &&
          traceCon.desc
        "
        class="toPay"
        @click="goWuliu(detail.logisticsMore)"
      >
        查看物流
      </div>
    </div>

    <mloading v-if="showLoading"></mloading>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import icon from "@/components/iconfont.vue";
import { sendRequest } from "@/assets/public";
import mloading from "@/components/loading.vue";
export default {
  components: {
    "qdd-icon": icon,
    mloading,
  },
  data() {
    return {
      isShowTips: false,
      order_key: "123123123123",
      oderId: "", //订单编号
      detail: {},
      residueTime: "", //代付款失效时间
      verify_time_format: "", //待确认失效时间
      applyCase: [],
      applyDetail: {},
      isShowTime: true,
      order_id: "",
      traceCon: {},
      showWuLiu: false,
      showLoading: true,
    };
  },
  mounted() {
    this.oderId = this.$route.query.oderId;
    console.log(this.$route.query.oderId);
    this.order_id = this.$route.query.xh_id;
    this.getDetail();
  },
  methods: {
    // 查看物流
    goSeeWuLiu(id) {
      console.log(id);
      this.$router.push({
        name: "wuliu_info",
        query: { xh_id: id ? id : "990000776" },
      });
    },
	jump2(){ //交易快照跳转
		this.$router.push({
		  name: "SnapshotDetails",
		  query: { oderId: this.oderId,order_parent_sn:this.detail.order_parent_sn },
		});
	},
    async trace() {
      this.showLoading = true;
      let { content, status, msg } = await sendRequest("order/trace", {
        order_id: this.order_id ? this.order_id : this.oderId,
      });
      if (status == "200") {
        this.showLoading = false;
        this.traceCon = content.list[0] || {};
      } else {
        this.showLoading = false;
      }
    },
    //去查看物流详情
    goWuliu(logisticsMore) {
      if (logisticsMore == 1) {
        this.$router.push({
          path: "/wuliuList",
          query: { xh_id: this.order_id },
        });
      } else if (logisticsMore == 0) {
        this.$router.push({
          path: "/wuliu_info",
          query: { xh_id: this.order_id },
        });
      }
    },
    async getDetail() {
      let res = await sendRequest("order/detail", {
        order_id: this.oderId,
      });

      if (res.content.surplus_time < 0) {
        this.isShowTime = false;
      }

      this.detail = res.content;
      if (this.detail.status == 11) {
        // 代付款过期时间
        let current_time = Date.parse(new Date()) / 1000;
        let surplus_time =
          parseInt(this.detail.add_time) +
          parseInt(this.detail.life_time) -
          current_time;
        let times = setInterval(() => {
          surplus_time--;
          let myTime = this.getTime(surplus_time);
          this.residueTime = myTime;
          if (surplus_time <= 0) {
            this.onLoad();
            clearInterval(times);
          }
        }, 1000);
      }

      if (this.detail.status == 30 && this.detail.goods_type != 2) {
        // 待收货时间
        let verify_time = this.detail.surplus_time;

        this.verify_time_format = this.formatDuring(
          parseInt(verify_time) * 1000
        );
      }
      if (this.detail.wl_danhao == "") {
        this.showWuLiu = false;
      } else {
        this.showWuLiu = true;
      }
      if (this.detail.goods_type != 2) {
        this.trace();
      } else {
        this.showLoading = false;
      }
    },
    formatDuring(mss) {
      var days = parseInt(mss / (1000 * 60 * 60 * 24));
      var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (mss % (1000 * 60)) / 1000;
      return days + " 天 " + hours + " 小时 " + minutes + " 分钟 ";
    },
    getTime(time, day) {
      let h = parseInt(time / 60 / 60);
      let m = parseInt((time - h * 60 * 60) / 60);
      let s = time - 3600 * h - m * 60;
      return h + " 时 " + m + " 分 " + s + " 秒";
    },
    goAffirm(id) {
      let _this = this;
      Dialog.confirm({
        message: "您是否确认收货？",
        confirmButtonText: "确定",
        confirmButtonColor: "#FD3E3E",
      })
        .then(() => {
          _this.getHuo(id);
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    async getHuo(id, sure) {
      let _this = this;
      this.showLoading = true;
      let { content, status, msg } = await sendRequest("order/confirm", {
        order_id: id,
        is_sure: 2,
      });
      this.showLoading = false;

      if (status == "200") {
        if (this.detail.goods_type == 2) {
          Toast("确认自提成功");
          setTimeout(function () {
            _this.$router.push({ path: "/order", query: { type: 40 } });
          }, 2000);
        } else {
          Toast("确认收货成功");
          setTimeout(function () {
            _this.$router.push({ path: "/order", query: { type: 40 } });
          }, 2000);
        }
      } else {
        Toast(msg);
      }
    },
    goPlan(orderSn) {
      this.$router.push({
        path: "/customerServiceDetails",
        query: { applySn: orderSn },
      });
    },
    // 复制文本内容
    copyLink() {
      let _this = this;
      let clipboardObj = new this.clipboard(".cobyDomObj");
      clipboardObj.on("success", function () {
        Toast("复制成功");
      });
      clipboardObj.on("error", function () {
        Toast("复制失败");
      });
    },
  },
};
</script>
<style>
.my_pop .van-hairline--left {
  background: #fc3e3e;
}
</style>
<style scoped>
.cobyDomObj {
  margin-left: 0.2rem;
}

.n_wuliu {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  /* margin-top: 0.6rem;
  border-bottom: 1px solid #eee;
  position: relative;
  overflow: hidden; */
}
.wl_no {
  width: 13rem !important;
  font-size: 0.52rem;
  padding-left: 0.5rem;
}

.n_wuliu article {
  font-size: 0.52rem;
}

.n_wuliu .w117 {
  width: 11.7rem;
  padding-left: 0.4rem;
}

.n_wuliu p {
  font-size: 0.48rem;
  color: #999999;
  padding-top: 0.2rem;
}

.iconnavigate-right {
  /* position: absolute; */
  /* top: 1rem; */
  /* right: 0.4rem; */
}

.pelase_hoder.maxHeight {
  height: 1.5rem;
}

.refundtips.maxHeight {
  bottom: -2rem;
}

.pelase_hoder {
  height: 1rem;
}

/*申请退款提示*/
.peihuo_tips {
  width: 8rem;
  padding: 0.3rem 0.8rem;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  font-size: 0.56rem;
  line-height: 0.9rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.3rem;
}

/* s申请退款原因弹框*/
.mod {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
}

.refund_pop {
  width: 15rem;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 10;
}

.refund_pop h2 {
  font-size: 0.68rem;
  color: #333333;
  padding: 0.2rem 0;
  text-align: center;
}

.refund_pop ul {
  max-height: 10rem;
  overflow-y: auto;
  padding: 0 0.8rem;
}

.refund_pop ul li {
  float: left;
  width: 100%;
  height: 2rem;
  line-height: 2rem;
  font-size: 0.56rem;
  color: #666666;
  border-bottom: 1px solid #eee;
  position: relative;
}

.refund_pop ul li em {
  position: absolute;
  top: 0;
  right: 0;
  width: 0.8rem;
  height: 2rem;
  background: url("http://statics.7dingdong.com/static/wx_program_img/integral_mall/weixuanzho.png")
    no-repeat center center;
  background-size: 0.6rem 0.6rem;
  display: block;
}

.refund_pop ul li.active em {
  background: url("http://statics.7dingdong.com/static/wx_program_img/integral_mall/xuanzhong.png")
    no-repeat center center !important;
  background-size: 0.6rem 0.6rem !important;
}

.refund_pop ul li:last-child {
  border-bottom: none;
}

.refund_pop .refund_sure {
  width: 15rem;
  height: 2rem;
  line-height: 2rem;
  color: #fff;
  font-size: 0.6rem;
  text-align: center;
  background: #fd3e3e;
  display: block;
}

.goPhone {
  color: #333333;
}

.refundtips {
  position: absolute;
  /* bottom: -0.5rem; */
  left: 1rem;
  z-index: 9;
  padding: 0 0.8rem;
  height: 1.76rem;
  line-height: 1.76rem;
  border-radius: 0.2rem;
  color: #999;
  font-size: 0.56rem;
  background: #fff;
  width: 11rem;
  box-shadow: 0 0 4px rgba(253, 62, 62, 0.2);
}

.header {
  position: relative;
  height: 3.4rem;
}

.header img {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 0;
  left: 0;
  height: 3.4rem;
}

.status {
  position: relative;
  z-index: 1;
  text-align: left;
  font-size: 0.6rem;
  color: #ffffff;
  padding: 0.68rem 0 0.4rem 0.78rem;
}

.bold {
  font-weight: bold;
}

.text_zi {
  font-size: 0.5rem;
}

.status > div {
  margin-left: 0.4rem;
}

.status .icongantanhao {
  position: relative;
  top: 0.08rem;
}

.desc {
  font-size: 0.48rem;
  margin-top: 0.28rem;
  font-weight: 500;
}

.address {
  background: #ffffff;
  padding: 0.6rem;
  text-align: left;
  font-size: 0.6rem;
}

.gray {
  font-size: 0.48rem;
  color: #999;
}

.ml30 {
  margin-left: 0.6rem;
}

.userName {
  margin-bottom: 0.28rem;
  font-size: 0.52rem;
}

.iconposition {
  margin-top: 0.6rem;
}

.goods {
  background: #ffffff;
  margin: 0.4rem 0 0;
  padding: 0.4rem 0.8rem;
}

.goods img {
  width: 4rem;
  height: 4rem;
}

.right_con {
  width: 8.66rem;
  margin-left: 0.8rem;
  text-align: left;
}

.goods_name {
  font-size: 0.6rem;
  font-weight: 500;
  margin-bottom: 0.4rem;
}

.right_con .flex_b {
  margin-top: 0.6rem;
}

.right_con .flex_b .gray {
  line-height: 0.86rem;
}

.jifen .red {
  font-size: 0.72rem;
  font-weight: bold;
}

.badge {
  font-size: 0.42rem;
  color: #fd3e3e;
  border: 1px solid #fd3e3e;
  border-radius: 0.4rem;
  line-height: 0.8rem;
  padding: 0 0.2rem;
  margin-left: 0.2rem;
}

.total {
  background: #ffffff;
  padding: 0 0.8rem;
  margin-bottom: 0.4rem;
}

.wrap {
  border-top: 1px solid #ddd;
  font-size: 0.56rem;
  padding: 0.4rem 0;
  text-align: left;
}

.wrap p {
  margin-bottom: 0.4rem;
}

.wrap p:last-child {
  margin-bottom: 0;
}

.fs24 {
  font-size: 0.48rem;
  margin-left: 0.24rem;
}

.express {
  font-size: 0.56rem;
  margin-bottom: 0.4rem;
  align-items: top;
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  padding: 0.2rem 0.8rem;
  margin-bottom: 0.4rem;
}
.exp_wl {
  width: 9rem;
}

.list {
  background: #ffffff;
  padding: 0.4rem 0.8rem 0;
}

.list li {
  padding-bottom: 0.4rem;
  color: #999;
  font-size: 0.48rem;
}

.contact {
  background: #ffffff;
  margin: 0.4rem 0;
  height: 1.76rem;
  line-height: 1.76rem;
  font-size: 0.56rem;
  font-weight: 500;
  text-align: center;
}

.contact span {
  margin-left: 0.4rem;
}

.footer {
  background: #ffffff;
  padding: 0 0.8rem;
  overflow: hidden;
}

.footer div {
  width: 3.8rem;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: center;
  font-size: 0.56rem;
  float: right;
  border-radius: 0.6rem;
  margin: 0.4rem;
}

.toPay {
  background: #fd3e3e;
  color: #fff;
  border: 1px solid #fd3e3e;
  margin: 0 20px;
}

.cancel {
  color: #999999;
  border: 1px solid #999;
}
</style>